import { MarkaeklemodalPage } from './../../Yonetim/MarkaIslemleri/markaeklemodal/markaeklemodal';
import { AksesuareklemodalPage } from './../../Yonetim/aksesuareklemodal/aksesuareklemodal';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Ortak } from './../../../providers/ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
import { Camera } from '@ionic-native/camera';
import { SelectSearchableComponent } from 'ionic-select-searchable';
@Component({
  selector: 'page-kayit-form',
  templateUrl: 'kayit-form.html',
})
export class KayitFormPage {
  @ViewChild('myselect') selectComponent: SelectSearchableComponent;
  secilencari = "";
  cariler = [];

  gununtarihi;
  tarihformati;
  isler: any = { ID: -1, DurumID: 1,SorumluPersonelID:""};
  gidenaksesuar = [];
  tarih: any;
  MarkaListesi = [];
  aranan = "";
  skip: number = 0;
  take: number = 200;
  DurumListesi = [];
  vWKayit: any = {};
  islemyapan = this.ortak.storagePersonelGetir.Name;
  base64Image: string;
  resimgoster: string;
  kayitliresim = "assets/imgs/logo.png"
  resimklasor = [];
  AciklamaListesi = [];
  personelListesi=[];
  aktarilacakCariKart: any = { ID: -1, Definition_: "", Telnumber: "" ,Bakiyesi:"",GsmNumber:""};
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public view: ViewController,
    public ortak: Ortak,
    public camera: Camera,
    public modalCtrl: ModalController,
    public toast: ToastController,
    public viewCtrl: ViewController,
    public navParams: NavParams) {

    if (navParams.get("vWKayit") != null) {
      this.vWKayit = navParams.get("vWKayit");
      var data = new FormData();
     
      data.append("Servis_id", this.vWKayit.ID);
      this.bllOrtak.islem(data, "ServisGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.isler = Sonuc.SonucObject;
        if (this.isler.ResimYolu != null) {
          this.kayitliresim = this.ortak.storageSunucuAdresiGetir + this.isler.ResimYolu;
        }
        else
          this.kayitliresim = "assets/imgs/logo.png";
      }
      )

    }
    // this.cariSec();
  }
  userChanged(event: { Component: SelectSearchableComponent, value: any }) {


    if (event.value != null) {
      this.aktarilacakCariKart.ID = event.value.ID;
      this.aktarilacakCariKart.Definition_ = event.value.Definition_;
      this.aktarilacakCariKart.GsmNumber = event.value.GsmNumber;
      this.aktarilacakCariKart.Addr1 = event.value.Addr1;
      this.aktarilacakCariKart.Ilgili = event.value.Ilgili;
      this.aktarilacakCariKart.Bakiyesi=event.value.Bakiyesi;
  
      if(this.aktarilacakCariKart.Bakiyesi>0)
      this.ortak.showBasicAlert("Dikkat", "Seçilen müşterinin ödenmemiş bakiyesi var");
      


    }
    else if (event.value == null) {
      this.aktarilacakCariKart.ID = "";
      this.aktarilacakCariKart.Definition_ = "";
      this.aktarilacakCariKart.GsmNumber = "";
      this.aktarilacakCariKart.Addr1 = "";
      this.aktarilacakCariKart.Ilgili = "";
      this.aktarilacakCariKart.ID = -1;
     
    }


  }
  onClose() {
    let toast = this.toast.create({
      message: 'Seçim Yapıldı',
      duration: 1000
    });
    toast.present();
  }
  openFromCode() {
    this.selectComponent.open();
  }
  ionViewDidLoad() {
    this.MusterileriGetir();
    this.MarkalariGetir();
    this.DurumGetir();
    this.AciklamaGetir();
    this.servisaksesuargetir();
    this.PersonelleriGetir();
  }
  servisaksesuargetir() {
    var formData = new FormData();
    formData.append("servisaksesuar", JSON.stringify(this.vWKayit));

    this.bllOrtak.islem(formData, "ServisAksesuarGetir", "", false).then(a => {
      var sonuc = <any>a;

      this.gidenaksesuar = sonuc.SonucObject;
    })


  }

  kaydet() {
    var formData = new FormData();
    if (this.boslukKontrol()) {
      if (this.base64Image != null)
        formData.append("base64", this.base64Image);
      this.isler.AdSoyad = this.aktarilacakCariKart.Definition_;
      this.isler.GsmNo = this.aktarilacakCariKart.GsmNumber;
      this.isler.Adres = this.aktarilacakCariKart.Addr1;
      this.isler.CariID = this.aktarilacakCariKart.ID;
      this.isler.OdemeYapildimi = "Odeme Yapılmadı"
      if(this.isler.SorumluPersonelID==null||this.isler.SorumluPersonelID=="")
      {
        this.isler.SorumluPersonelID=this.ortak.storagePersonelGetir.ID;
      }

      formData.append("Servis_json", JSON.stringify(this.isler, this.isler.IslemYapan = this.islemyapan));
      formData.append("Aksesuars", this.gidenaksesuar.join());
      this.bllOrtak.islem(formData, "ServisEkle", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc != 1) this.ortak.showBasicAlert("Hata", "Servis Kaydı Yapılamadı");
        this.viewCtrl.dismiss();
      })
    }
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.aktarilacakCariKart.Definition_ == null || this.aktarilacakCariKart.Definition_ == "") {
      mesaj = mesaj + "Lütfen Müşteri adını giriniz. <br/>";
    }
  else  if (this.aktarilacakCariKart.GsmNumber == null || this.aktarilacakCariKart.GsmNumber == "") {
      mesaj = mesaj + "Lütfen telefon numarasını giriniz. <br/>";
    }
    else  if (this.isler.CihazAriza == null || this.isler.CihazAriza == "") {
      mesaj = mesaj + "Lütfen arızayı  yazınız. <br/>";
    }
    else  if (this.isler.CihazModel == null || this.isler.CihazModel == "") {
      mesaj = mesaj + "Lütfen cihaz modelini  yazınız. <br/>";
    }
    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  MarkalariGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "MarkaListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.MarkaListesi = sonuc.SonucObject;
    })
  }
  DurumGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "DurumListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.DurumListesi = sonuc.SonucObject;
    })
  }
  AciklamaGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "AksesuarListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.AciklamaListesi = sonuc.SonucObject;
    })
  }
  PersonelleriGetir()
  {
  this.bllOrtak.islemWithoutPost("PersonelGetirServisKayit","",false).then(a=>{
    var sonuc=<any>a;
    this.personelListesi=sonuc.SonucObject;
  })
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  fileUpload(event) {
    let fd = new FormData();
    fd.append('file', event.srcElement.files[0]);
    var file = event.srcElement.files[0]
    if (file) {
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64Image = btoa(binaryString);
    this.kayitliresim = 'data:image/jpeg;base64,' + this.base64Image;
  }
  FotografCek() {
    this.camera.getPicture({
      destinationType: this.camera.DestinationType.DATA_URL,
      sourceType: this.camera.PictureSourceType.CAMERA,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 1000,
      targetHeight: 1000
    }).then((imageData) => {
      // imageData is a base64 encoded string
      this.base64Image = imageData;
      this.kayitliresim = 'data:image/jpeg;base64,' + this.base64Image;
    }, (err) => {
    });
  }
  GaleriyeGit() {
    this.camera.getPicture({
      destinationType: this.camera.DestinationType.DATA_URL,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 1000,
      targetHeight: 1000
    }).then((imageData) => {
      // imageData is a base64 encoded string
      this.base64Image = imageData;
      this.kayitliresim = 'data:image/jpeg;base64,' + this.base64Image;
    }, (err) => {
      console.log(err);
    });
  }


  presentToast(mesaj, sure) {
    let toast = this.toast.create({
      message: mesaj,
      duration: sure,
      showCloseButton: false,
      // closeButtonText: "Tamam",
      position: 'top'
    });
    toast.present();
    // this.sonEklenen = mesaj;
  }
  MusterileriGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "CariListesi", "", false).then(a => {

      var sonuc = <any>a;
      this.cariler = sonuc.SonucObject;
      


    })
  }
  markaekle() {
    let modal = this.modalCtrl.create(MarkaeklemodalPage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  aksesuarekle() {
    let modal = this.modalCtrl.create(AksesuareklemodalPage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/kayit-form/kayit-form.ts